import React from 'react';
import { ModalHeader, ModalFooter } from 'reactstrap';
import { Button } from 'user/components';
import { SpinnerWrapper } from 'components/Spinner/spinner';
import { ModalContainer, ModalBodyContainer, ModalFooterSpacer, ModalTitle } from './styles';

export const Modal = ({ children, isOpen = true, autoFocus = false }) => (
  <ModalContainer isOpen={isOpen} autoFocus={autoFocus}>
    {children}
  </ModalContainer>
);

export const Header = ({ children }) => (
  <ModalHeader>
    <ModalTitle>{children}</ModalTitle>
  </ModalHeader>
);

export const Body = ({ children, loading }) => (
  <SpinnerWrapper loading={loading}>
    <ModalBodyContainer>{children}</ModalBodyContainer>
  </SpinnerWrapper>
);

export const Footer = ({ children }) => (
  <ModalFooter>
    <ModalFooterSpacer>{children}</ModalFooterSpacer>
  </ModalFooter>
);

export const FooterButton = ({ label, onClick, disabled, autoFocus }) => (
  <Button
    small
    primaryBlue
    primaryGreenBorder
    removeMargin
    type="submit"
    onClick={onClick}
    disabled={disabled}
    autoFocus={autoFocus}
  >
    {label}
  </Button>
);
